import {
  put,
  select,
  apply,
  fork,
  call,
  delay,
} from 'redux-saga/effects';
import {
  getClientAlias,
  getLanguage,
  getTournamentId,
  getMatchStatus,
  getSeasonId,
} from 'reducers';
import { TournamentLiveTableRequest } from 'fishnet-api';
import { TOURNAMENT_INTERVAL } from 'constants/fishnet';
import { updateTournamentLiveTableFailed, updateTournamentLiveTable } from 'actions/fishnet/index';
import { isEnded } from 'utils/matchstatus';
import { MIN } from 'constants/app';
import { pollFishnet, takeMatchUpdate } from '../utilLCR';
import { sagaTryLog } from '../utilSagas';

function* loadTable(matchId) {
  const clientAlias = yield select(getClientAlias);
  const language = yield select(getLanguage);
  const tId = yield select(getTournamentId, matchId);
  const sId = yield select(getSeasonId, matchId);

  const request = new TournamentLiveTableRequest(tId, sId, clientAlias, language);
  const response = yield apply(request, request.get);


  if (response && !response.error) {
    const table = {
      matchId,
      table: response,
    };
    yield put(updateTournamentLiveTable(table, matchId));
  } else if (response && response.error) {
    yield put(updateTournamentLiveTableFailed(response, matchId));
    throw response;
  } else {
    throw new Error('Update tournament_livetable failed');
  }
}

// atleast once and then once after match end
function* pollTournamentLiveTable(matchId) {
  yield call(takeMatchUpdate, matchId); // wait on one succesful match_info / match_timelinedelta

  // poll on interval TOURNAMENT_INTERVAL
  yield fork(
    pollFishnet,
    { pollInterval: TOURNAMENT_INTERVAL },
    loadTable,
    matchId,
  );

  // update after match ended
  for (;;) {
    const status = yield select(getMatchStatus, matchId);

    if (isEnded(status)) {
      yield delay(1 * MIN);
      yield call(sagaTryLog(loadTable, matchId));
      return;
    }

    yield call(takeMatchUpdate, matchId);
  }
}

export default pollTournamentLiveTable;
